export default "__VITE_ASSET__CzgMzxBm__"